import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { Onboarding } from '@confluence/onboarding';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';

export const OnboardingRoute = () => (
	<ErrorBoundary attribution={Attribution.FLYWHEEL_ACTIVATION}>
		<Onboarding />
	</ErrorBoundary>
);

OnboardingRoute.NAVIGATION_PARAMS = ({ name }: RouteMatch) => ({
	Screen: {
		screenEvent: { name: 'onboardingContainerScreen' },
		pageState: { routeName: name },
	},
	MainLayout: false,
});
